import get from "lodash/get"
import {
  GET_ONLINE_PRODUCTS_FULFILLED,
  GET_ONLINE_PRODUCTS_PENDING,
  GET_ONLINE_PRODUCTS_FAILED,
  CHANGE_TERM_PLAN,
  INITIALIZE_PRODUCT_RESULTS,
  RESET_ECOM_PRICING,
  SET_CUSTOMER_ADDRESS,
  GET_COMMERCIAL_SERVLET_PENDING,
  GET_COMMERCIAL_SERVLET_FULFILLED,
  GET_COMMERCIAL_SERVLET_FAILED,
  GET_CLOUDCRAZE_SERVICE_DAYS_PENDING,
  GET_CLOUDCRAZE_SERVICE_DAYS_FULFILLED,
  GET_CLOUDCRAZE_SERVICE_DAYS_FAILED,
  GET_OUTAGES_PENDING,
  GET_OUTAGES_FULFILLED,
  GET_OUTAGES_FAILED,
  GET_CLOUDCRAZE_DELIVERY_SCHEDULE_PENDING,
  GET_CLOUDCRAZE_DELIVERY_SCHEDULE_FULFILLED,
  GET_CLOUDCRAZE_DELIVERY_SCHEDULE_FAILED,
  CLEAR_ONLINE_PRODUCTS_USER_SELECTION,
  SET_ONLINE_PRODUCTS_USER_SELECTION,
  GET_ECOMMERCE_PRICING_PENDING,
  GET_ECOMMERCE_PRICING_FULFILLED,
  GET_ECOMMERCE_PRICING_FAILED,
  CHANGE_WASTE_TYPE,
  SET_ONLINE_SELECTED_PRODUCT,
  GET_SERVLET_DETAILS_FULFILLED,
  GET_SERVLET_DETAILS_PENDING,
  GET_HOLIDAY_JSON_PENDING,
  GET_HOLIDAY_JSON_FULFILLED,
  GET_HOLIDAY_JSON_FAILED,
  GET_SE_CAPACITY_PLANNER_PENDING,
  GET_SE_CAPACITY_PLANNER_FULFILLED,
  GET_SE_CAPACITY_PLANNER_FAILED,
  GET_ERROR_MESSAGE_SERVLET_FULFILLED,
  GET_ERROR_MESSAGE_SERVLET_PENDING,
  GET_ERROR_MESSAGE_SERVLET_FAILED,
  GET_BRIGHTEDGE_MESSAGE_SERVLET_PENDING,
  GET_BRIGHTEDGE_MESSAGE_SERVLET_FAILED,
  GET_BRIGHTEDGE_MESSAGE_SERVLET_FULFILLED,
} from "constants-lib/actionTypes"

const initialState = {
  productItems: [],
  selectedProductId: ``,
  selectedProductName: ``,
  userSelection: {
    activeStep: 0,
  },
  locale: ``,
  term: `long`,
  outagesDetails: {},
  servletErrorMessageState: ``,
  servletErrorMessage: [],
  brightedgeErrorMessageState: "",
  brightedgeServletErrorMessage: {},
}

export const customSort = (payload) =>
  payload?.sort((a, b) => {
    const getOrder = (productName) => {
      if (productName?.includes("Construction")) return 1
      if (productName?.includes("Recycling")) return 2
      return 0
    }

    return getOrder(a?.productName) - getOrder(b?.productName)
  })

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ONLINE_PRODUCTS_FULFILLED: {
      return {
        ...state,
        onlineEcommercePricing: action.payload,
        initialEcommercePricing: action.payload,
        onlineProductInformationStatus: `fulfilled`,
        selectedWasteType: get(
          action.payload,
          `products[0].materials[0].id`,
          ``,
        ),
        userSelection: {
          ...state.userSelection,
          selectedWasteType: get(
            action.payload,
            `products[0].materials[0].id`,
            ``,
          ),
          buNumberfield: get(
            action.payload,
            `products[0].business_unit_number`,
          ),
          facility_id: get(action.payload, `products[0].facility_id` || ``),
        },
      }
    }

    case CHANGE_TERM_PLAN:
      return {
        ...state,
        term: action.payload,
      }

    case INITIALIZE_PRODUCT_RESULTS: {
      return {
        ...state,
        productItems: [],
        selectedProductId: ``,
        userSelection: {
          ...state.userSelection,
          activeStep: 0,
        },
      }
    }

    case RESET_ECOM_PRICING: {
      return {
        ...state,
        onlineEcommercePricing: { ...state.initialEcommercePricing },
      }
    }

    case SET_CUSTOMER_ADDRESS: {
      return {
        ...state,
        userSelection: { ...state.userSelection, activeStep: 0 },
        onlineProductInformationStatus: ``,
        productItems: [],
        selectedProductId: ``,
        selectedProductName: ``,
        selectedWasteType: ``,
        initialEcommercePricing: {},
        servletState: ``,
      }
    }

    case GET_COMMERCIAL_SERVLET_PENDING: {
      return {
        ...state,
        uniqueProducts: {},
      }
    }

    case GET_COMMERCIAL_SERVLET_FULFILLED: {
      return {
        ...state,
        uniqueProducts: action.payload,
      }
    }

    case GET_COMMERCIAL_SERVLET_FAILED: {
      return {
        ...state,
      }
    }

    case GET_CLOUDCRAZE_SERVICE_DAYS_PENDING: {
      return {
        ...state,
        pickupDays: {},
      }
    }

    case GET_CLOUDCRAZE_SERVICE_DAYS_FULFILLED: {
      return {
        ...state,
        pickupDays: action.payload,
      }
    }

    case GET_CLOUDCRAZE_SERVICE_DAYS_FAILED: {
      return {
        ...state,
        pickupDays: {},
      }
    }

    case GET_OUTAGES_PENDING: {
      return {
        ...state,
        outagesDetails: {
          outages: {},
          getOutagesStatus: "pending",
        },
      }
    }

    case GET_OUTAGES_FULFILLED: {
      return {
        ...state,
        outagesDetails: {
          ...action.payload,
          getOutagesStatus: "fulfilled",
        },
      }
    }

    case GET_OUTAGES_FAILED: {
      return {
        ...state,
        outagesDetails: {
          getOutagesStatus: "failed",
        },
      }
    }

    case GET_CLOUDCRAZE_DELIVERY_SCHEDULE_PENDING: {
      return {
        ...state,
        deliverySchedule: {},
      }
    }

    case GET_CLOUDCRAZE_DELIVERY_SCHEDULE_FULFILLED: {
      return {
        ...state,
        deliverySchedule: action.payload,
      }
    }

    case GET_CLOUDCRAZE_DELIVERY_SCHEDULE_FAILED: {
      return {
        ...state,
      }
    }

    case GET_ONLINE_PRODUCTS_PENDING: {
      return {
        ...state,
        userSelection: {
          ...state.userSelection,
        },
        onlineEcommercePricing: {},
        onlineProductInformationStatus: `pending`,
        selectedWasteType: ``,
        locale: action.locale || action.payload,
      }
    }

    case GET_ONLINE_PRODUCTS_FAILED: {
      return {
        ...state,
        onlineEcommercePricing: {},
        onlineProductInformationStatus: `failed`,
        selectedWasteType: ``,
      }
    }

    case CLEAR_ONLINE_PRODUCTS_USER_SELECTION: {
      return {
        ...state,
        userSelection: {
          ...state.userSelection,
          ...action.payload,
        },
      }
    }

    case SET_ONLINE_PRODUCTS_USER_SELECTION: {
      return {
        ...state,
        userSelection: {
          ...state.userSelection,
          ...action.payload,
        },
      }
    }

    case GET_ECOMMERCE_PRICING_PENDING: {
      return {
        ...state,
        onlineEcommercePricingStatus: `pending`,
        userSelection: {
          ...state.userSelection,
          selectedWasteType: ``,
        },
      }
    }

    case GET_ECOMMERCE_PRICING_FULFILLED: {
      const newState = {
        ...state,
        onlineEcommercePricingStatus: `fulfilled`,
        userSelection: {
          ...state.userSelection,
        },
      }
      const str = JSON.stringify(state.onlineEcommercePricing)
      newState.onlineEcommercePricing = { ...JSON.parse(str) }
      newState.onlineEcommercePricing.products.forEach((element) => {
        element.attributes.forEach((attribute) => {
          if (
            !action.payload.service_type ||
            attribute.service_type === action.payload.service_type
          ) {
            // eslint-disable-next-line no-param-reassign
            attribute.materials[0].pricing.total_amount =
              action.payload.products.find(
                (s) => s.id === element.id,
              ).attributes.pricing.total_amount
          }
        })
      })
      return newState
    }

    case GET_ECOMMERCE_PRICING_FAILED: {
      return {
        ...state,
        onlineEcommercePricingStatus: `failed`,
        userSelection: {
          ...state.userSelection,
          selectedWasteType: ``,
        },
      }
    }

    case CHANGE_WASTE_TYPE: {
      return {
        ...state,
        userSelection: {
          ...state.userSelection,
          selectedWasteType: action.payload,
        },
      }
    }

    case SET_ONLINE_SELECTED_PRODUCT: {
      return {
        ...state,
        selectedProductId: action.payload.productId || action.payload,
        selectedProductName: action.payload.productName || ``,
      }
    }

    case GET_SERVLET_DETAILS_FULFILLED:
      return {
        ...state,
        productItems: action.payload,
        selectedProductId: state.selectedProductId
          ? state.selectedProductId
          : customSort(action.payload)[0]?.productId ||
            action.payload[0].productId,
        selectedProductName: state.selectedProductName
          ? state.selectedProductName
          : customSort(action.payload)[0]?.productName ||
            action.payload[0].productName,
        servletState: `fulfilled`,
      }

    case GET_SERVLET_DETAILS_PENDING:
      return {
        ...state,
        servletState: `pending`,
      }

    case GET_HOLIDAY_JSON_PENDING: {
      return {
        ...state,
        holidaysList: {},
        holidaysListStatus: `pending`,
      }
    }

    case GET_HOLIDAY_JSON_FULFILLED: {
      return {
        ...state,
        holidaysList: action.payload,
        holidaysListStatus: `fulfilled`,
      }
    }

    case GET_HOLIDAY_JSON_FAILED: {
      return {
        ...state,
        holidaysList: {},
        holidaysListStatus: `failed`,
      }
    }

    case GET_SE_CAPACITY_PLANNER_PENDING: {
      return {
        ...state,
        seCapacityPlanner: {},
        seCapacityPlannerStatus: `pending`,
      }
    }

    case GET_SE_CAPACITY_PLANNER_FULFILLED: {
      return {
        ...state,
        seCapacityPlanner: action.payload,
        seCapacityPlannerStatus: `fulfilled`,
      }
    }

    case GET_SE_CAPACITY_PLANNER_FAILED: {
      return {
        ...state,
        seCapacityPlanner: {},
        seCapacityPlannerStatus: `failed`,
      }
    }

    case GET_ERROR_MESSAGE_SERVLET_FULFILLED:
      return {
        ...state,
        servletErrorMessage: action.payload,
        servletErrorMessageState: `fulfilled`,
      }

    case GET_ERROR_MESSAGE_SERVLET_PENDING:
      return {
        ...state,
        servletErrorMessageState: `pending`,
        servletErrorMessage: initialState.servletErrorMessage,
      }

    case GET_ERROR_MESSAGE_SERVLET_FAILED:
      return {
        ...state,
        servletErrorMessageState: `failed`,
      }

    case GET_BRIGHTEDGE_MESSAGE_SERVLET_FULFILLED:
      return {
        ...state,
        brightedgeServletErrorMessage: action.payload,
        brightedgeErrorMessageState: `fulfilled`,
      }

    case GET_BRIGHTEDGE_MESSAGE_SERVLET_PENDING:
      return {
        ...state,
        brightedgeErrorMessageState: `pending`,
        brightedgeServletErrorMessage:
          initialState.brightedgeServletErrorMessage,
      }

    case GET_BRIGHTEDGE_MESSAGE_SERVLET_FAILED:
      return {
        ...state,
        brightedgeErrorMessageState: `failed`,
      }

    default:
      return state
  }
}
